/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable arrow-parens */
/* eslint-disable object-curly-newline */
/* eslint-disable react/button-has-type */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  MdHome,
  MdWork,
  MdExitToApp,
  MdSettings,
  MdSchool,
  MdFlag,
  MdPerson,
} from 'react-icons/md';
import { FiCode } from 'react-icons/fi';
import { FaQuestionCircle } from 'react-icons/fa';
import { useLocation, Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';

import {
  Container,
  ViewTop,
  ViewBody,
  ViewBottom,
  ViewToolTip,
} from './styles';
import Letter from '~/assets/images/logoLetter.png';
import Logo from '~/assets/images/miniLogo.png';
import history from '~/services/history';
import { signOut } from '~/store/modules/auth/actions';

export default function Sider() {
  const user = useSelector((state) => state.user.profile);
  const role = useSelector((state) => state.user.profile.roles[0]);
  const dispatch = useDispatch();

  function onHandleExit() {
    dispatch(signOut());
  }

  const location = useLocation();

  return (
    <Container>
      <ViewTop>
        <div className="support">
          <img
            src={Letter}
            alt="Letter"
            style={{ width: 50, height: 60, marginTop: 10 }}
            onClick={() => history.push('/conquer')}
          />
          <img
            src={Logo}
            alt="miniLogo"
            style={{ width: 50, marginTop: 15 }}
            onClick={() => history.push('/conquer')}
          />
          <div className="support">
            <p
              style={{
                fontWeight: 'bold',
                marginTop: 10,
                color: '#090f35',
                fontSize: 15,
                textAlign: 'center',
              }}
            >
              Olá, {user.first_name}!
            </p>
          </div>
        </div>
        {role && role.slug === 'admin' ? (
          <div className="admin">
            <button
              onClick={() => history.push('/admin')}
              style={{
                background: '#000',
                border: 0,
                margin: 5,
              }}
            >
              <MdSettings size={30} color="#FFD700" />
            </button>
            <button
              onClick={() => history.push('/educatorChallenge')}
              style={{
                background: '#000',
                border: 0,
                margin: 5,
              }}
            >
              <MdSchool size={30} color="#FFD700" />
            </button>
          </div>
        ) : null}
      </ViewTop>

      <ViewBody>
        <div
          style={{
            marginBottom: 15,
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
            borderBottomColor: '#aaa',
            paddingBottom: 15,
          }}
          id="home"
        >
          <button
            onClick={() => history.push('/conquer')}
            style={{ background: 'none', border: 0 }}
          >
            <MdHome
              size={35}
              color={location.pathname === '/conquer' ? '#36ded6' : '#090f35'}
            />
          </button>
        </div>
        <UncontrolledTooltip delay={0} placement="right-start" target="home">
          <ViewToolTip>
            <p style={{ fontWeight: 'bold' }}>Dashboard</p>
            <p>Informações do seu perfil Apollo</p>
          </ViewToolTip>
        </UncontrolledTooltip>

        <div
          style={{
            marginBottom: 15,
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
            borderBottomColor: '#aaa',
            paddingBottom: 15,
          }}
          id="work"
        >
          <button
            onClick={() => history.push('/mail')}
            style={{ background: 'none', border: 0 }}
          >
            <MdWork
              size={30}
              color={location.pathname === '/mail' ? '#36ded6' : '#090f35'}
            />
          </button>
        </div>
        <UncontrolledTooltip delay={0} placement="right-start" target="work">
          <ViewToolTip>
            <p style={{ fontWeight: 'bold' }}>Vagas Disponíveis</p>
            <p>Encontre a vaga que você quer trabalhar.</p>
          </ViewToolTip>
        </UncontrolledTooltip>

        <div
          style={{
            marginBottom: 15,
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
            borderBottomColor: '#aaa',
            paddingBottom: 15,
          }}
          id="code"
        >
          <button
            onClick={() => history.push('/subjects')}
            style={{ background: 'none', border: 0 }}
          >
            <FiCode
              size={30}
              color={location.pathname === '/subjects' ? '#36ded6' : '#090f35'}
            />
          </button>
        </div>
        <UncontrolledTooltip delay={0} placement="right-start" target="code">
          <ViewToolTip>
            <p style={{ fontWeight: 'bold' }}>Desafios</p>
            <p>Desafios Técnicos e de Negócios.</p>
          </ViewToolTip>
        </UncontrolledTooltip>

        {/* <div
          style={{
            marginBottom: 15,
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
            borderBottomColor: '#aaa',
            paddingBottom: 15,
          }}
        >
          <button
            onClick={() => history.push('/tutoring')}
            style={{ background: 'none', border: 0 }}
          >
            <MdSchool
              size={30}
              color={location.pathname === '/tutoring' ? '#36ded6' : '#090f35'}
            />
          </button>
        </div> */}

        <button
          onClick={() => history.push('/scorecard')}
          style={{ background: 'none', border: 0 }}
          id="scorecard"
        >
          <MdFlag
            size={35}
            color={location.pathname === '/scorecard' ? '#36ded6' : '#090f35'}
          />
        </button>
        <UncontrolledTooltip
          delay={0}
          placement="right-start"
          target="scorecard"
        >
          <ViewToolTip>
            <p style={{ fontWeight: 'bold' }}>Meus Desafios</p>
            <p>Veja seus desafios corretos, errados e em correçāo.</p>
          </ViewToolTip>
        </UncontrolledTooltip>
      </ViewBody>

      <ViewBottom>
        <div className="bottom">
          <Link to="/profile">
            <div
              style={{
                marginBottom: 15,
                borderBottomWidth: 1,
                borderBottomStyle: 'solid',
                borderBottomColor: '#aaa',
                paddingBottom: 15,
              }}
            >
              {' '}
              <button style={{ background: 'none', border: 0 }}>
                <MdPerson
                  size={30}
                  color={
                    location.pathname === '/profile' ? '#36ded6' : '#090f35'
                  }
                />
              </button>
            </div>
          </Link>

          <Link to="/faq">
            <div
              style={{
                marginBottom: 15,
                borderBottomWidth: 1,
                borderBottomStyle: 'solid',
                borderBottomColor: '#aaa',
                paddingBottom: 15,
              }}
            >
              <button style={{ background: 'none', border: 0 }}>
                <FaQuestionCircle
                  size={30}
                  color={location.pathname === '/faq' ? '#36ded6' : '#090f35'}
                />
              </button>
            </div>
          </Link>
          <div
            style={{
              marginBottom: 15,
              paddingBottom: 15,
            }}
          >
            <button
              onClick={onHandleExit}
              style={{ background: 'none', border: 0 }}
            >
              <MdExitToApp size={30} color="#090f35" />
            </button>
          </div>
        </div>
      </ViewBottom>
    </Container>
  );
}
